import React from 'react';
import { func_datetime, func_validation, isStringTrimNotEmpty } from 'functions';
import Toggle from 'components/buttons/Toggle';
import { useCustomSelector } from 'hooks';
import { SubmenuTooltip } from 'components';

export function useControlTableColumns(props) {

    const { updateTrialStatusModalState, updateDeletedDateModalState, updateExtendDateModalState } = props

    const { userPermissions } = useCustomSelector("userManagementReducers");

    function getColumn_no() {
        let columnClassName = "columns__no";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "No",
            id: "no",
            accessor: "No",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value}</div>
                );
            },
            width: 200
        }
    }
    
    function getColumn_licenseKey() {
        let columnClassName = "columns__licenseKey";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "License Key",
            id: "licenseKey",
            accessor: "LicenseKey",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 200
        }
    }

    function getColumn_packageName() {
        let columnClassName = "columns__packageName";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Product Name",
            id: "packageName",
            accessor: "PackageName",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 200
        }
    }

    function getColumn_creationDate() {
        let columnClassName = "columns__creationDate";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Creation Date",
            id: "creationDate",
            accessor: "CreationDate",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 200
        }
    }

    function getColumn_activationDate() {
        let columnClassName = "columns__activationDate";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Activation Date",
            id: "activationDate",
            accessor: "ActivationDate",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 200
        }
    }

    function getColumn_isDeleted() {
        let columnClassName = "columns__isDeleted";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Status",
            id: "isDeleted",
            accessor: "IsDeleted",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = value? "Deleted":"Active"

                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 200
        }
    }

    function getColumn_deletedDate() {
        let columnClassName = "columns__deletedDate";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Deleted Date",
            id: "deletedDate",
            accessor: "DeletedDate",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis deletedDate_link"}>{value_formatted}</div>
                );
            },
            width: 200
        }
    }

    function getColumn_isTrial() {
        let columnClassName = "columns__isTrial";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Trial Status",
            id: "isTrial",
            accessor: "IsTrial",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
    
                return (
                    <div className={"noWrap-text-ellipsis"}>
                        <Toggle 
                            isActiveInit={value} 
                            onStateChange={false} 
                            onToggle={(userPermissions?.Internal_License_Update && !value)? () => updateTrialStatusModalState(props?.row?.original):()=>{}} 
                        />
                    </div>
                );
            },
            width: 200
        }
    }

    function getColumn_trialExpiredDate() {
        let columnClassName = "columns__trialExpiredDate";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Trial Expiry Date",
            id: "trialExpiredDate",
            accessor: "TrialExpiredDate",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 200
        }
    }

    function getColumn_remark() {
        let columnClassName = "columns__remark";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Remark",
            id: "remark",
            accessor: "Remark",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 200
        }
    }

    function getColumn_more() {
        let columnClassName = "columns__more";
    
        return {
            headerCellClassName: columnClassName,
            Header: "More",
            id: "more",
            accessor: "More",
            bodyCellClassName: columnClassName,
            Cell: (props) => {
                let data = props?.row?.original;
                let isDeleted = data?.IsDeleted;

                return (
                    <SubmenuTooltip
                        menuItems={[
                            {
                                label: "Delete",
                                isDisabled: !(userPermissions?.Internal_License_Update && !isDeleted),
                                disabledMsg: "License update permissions required",
                                onClick: () => {
                                    updateDeletedDateModalState(data);
                                }
                            },
                            {
                                label: "Extend Trial Date",
                                isDisabled: !(userPermissions?.Internal_License_Update && !isDeleted),
                                disabledMsg: "License update permissions required",
                                onClick: () => {
                                    updateExtendDateModalState(data);
                                }
                            }
                        ]}
                        isMenuArrowHidden isTargetHighlightedHidden
                    >
                        <div className={"more__value"} />
                    </SubmenuTooltip>
                );
            },
        }
    }

    return [
        getColumn_no(),
        getColumn_licenseKey(),
        getColumn_packageName(),
        getColumn_creationDate(),
        // getColumn_activationDate(),
        getColumn_isDeleted(),
        getColumn_deletedDate(),
        getColumn_isTrial(),
        getColumn_trialExpiredDate(),
        getColumn_remark(),
        getColumn_more()
    ]
}